// Per-biome arena boundary theming — the world's edge reads as a contained energy wall whose
// thickness, glow, height and pulse vary by biome (calm meadow ring vs a tall, fierce rift wall).
// Pure params picker (headless-testable); the renderer builds the torus + a translucent wall from it.

export interface BoundaryTheme {
  /** torus tube radius (ring thickness) */
  tube: number
  /** ring emissive intensity (base, before the sync pulse) */
  emissive: number
  /** translucent containment-wall opacity */
  wallOpacity: number
  /** containment-wall height (world units) */
  wallHeight: number
  /** emissive/opacity pulse speed (rad/sec) */
  pulse: number
}

// calm plains — thin, soft, slow
const MEADOW: BoundaryTheme = { tube: 0.6, emissive: 0.5, wallOpacity: 0.06, wallHeight: 6, pulse: 1.5 }
// desert — a touch thicker/brighter, low wall (heat shimmer)
const DUNES: BoundaryTheme = { tube: 0.7, emissive: 0.6, wallOpacity: 0.05, wallHeight: 5, pulse: 1.2 }
// graveyard — hollow bright ring, taller wall, eerie quicker flicker
const GRAVEYARD: BoundaryTheme = { tube: 0.6, emissive: 0.75, wallOpacity: 0.09, wallHeight: 7, pulse: 2.3 }
// rift — thick, fierce, tall, fast pulse
const RIFT: BoundaryTheme = { tube: 0.95, emissive: 1.0, wallOpacity: 0.13, wallHeight: 9, pulse: 3.0 }

const THEMES: Record<string, BoundaryTheme> = { meadow: MEADOW, dunes: DUNES, graveyard: GRAVEYARD, rift: RIFT }

/** The per-biome boundary theme for a map id; the calm meadow edge is the default. */
export function boundaryTheme(mapId: string): BoundaryTheme {
  return THEMES[mapId] ?? MEADOW
}
